import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "translateBtn", "translateProgress", "translateBar", "translateStatus", "translateLog", "translateCount", "translateBadge",
    "descBtn", "descProgress", "descBar", "descStatus", "descLog", "descCount", "descBadge"
  ]
  static values = { translateUrl: String, descriptionUrl: String }

  startTranslation() {
    const total = parseInt(this.translateCountTarget.textContent)
    this.runBatch(this.translateUrlValue, total, {
      btn: this.translateBtnTarget,
      progress: this.translateProgressTarget,
      bar: this.translateBarTarget,
      status: this.translateStatusTarget,
      log: this.translateLogTarget,
      count: this.translateCountTarget,
      badge: this.translateBadgeTarget
    })
  }

  startDescription() {
    const total = parseInt(this.descCountTarget.textContent)
    this.runBatch(this.descriptionUrlValue, total, {
      btn: this.descBtnTarget,
      progress: this.descProgressTarget,
      bar: this.descBarTarget,
      status: this.descStatusTarget,
      log: this.descLogTarget,
      count: this.descCountTarget,
      badge: this.descBadgeTarget
    })
  }

  async runBatch(url, total, ui) {
    ui.btn.disabled = true
    ui.btn.textContent = "処理中..."
    ui.btn.classList.add("opacity-50", "cursor-not-allowed")
    ui.progress.style.display = "block"
    ui.log.style.display = "block"

    let processed = 0
    let errors = 0
    const skipped = []
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content

    while (true) {
      const body = skipped.length > 0 ? `skip=${encodeURIComponent(skipped.join(","))}` : ""
      try {
        const response = await fetch(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            "X-CSRF-Token": csrfToken,
            "Accept": "application/json"
          },
          body: body
        })
        const data = await response.json()

        if (data.done) break

        if (data.error) {
          errors++
          if (data.skip_key) skipped.push(data.skip_key)
          this.appendLog(ui.log, `${data.name} - ${data.error}`, true)
        } else {
          processed++
          this.appendLog(ui.log, data.name)
        }

        const pct = Math.min(100, Math.round(((processed + errors) / total) * 100))
        ui.bar.style.width = `${pct}%`
        ui.status.textContent = `${processed}件完了${errors > 0 ? ` / ${errors}件エラー` : ""}`
        ui.count.textContent = Math.max(0, total - processed - errors)
      } catch (e) {
        errors++
        this.appendLog(ui.log, `通信エラー: ${e.message}`, true)
        if (errors > 10) break
      }
    }

    ui.bar.style.width = "100%"
    ui.btn.textContent = "完了"

    if (errors === 0) {
      ui.status.textContent = `${processed}件の処理が完了しました`
      ui.badge.className = "text-sm font-medium px-3 py-1 rounded-full bg-green-100 text-green-700"
      ui.count.textContent = "0"
    } else {
      ui.status.textContent = `${processed}件完了 / ${errors}件エラー`
      ui.badge.className = "text-sm font-medium px-3 py-1 rounded-full bg-red-100 text-red-700"
    }
  }

  appendLog(container, text, isError = false) {
    const div = document.createElement("div")
    div.textContent = isError ? `✗ ${text}` : `✓ ${text}`
    if (isError) div.classList.add("text-red-400")
    container.appendChild(div)
    container.scrollTop = container.scrollHeight
  }
}
